export interface CustomAuthoriserData {
    meetingId: string,
    userId: string,
    joinCode: string,
    authToken: string | undefined,
    clientId?: string,
}

const baseURL = import.meta.env.VITE_API_URL as string;

export const getUrl = (
    path: string,
    clientId: string | undefined,
    parameters?: string | undefined,
): URL => {

    const urlString = parameters ? `${baseURL}/${path}/${parameters}` : `${baseURL}/${path}`
    const url = new URL(urlString)

    if (clientId) {
        url.searchParams.append("clientId", clientId)
    }

    return url
}

export const createCustomToken = (info: CustomAuthoriserData): string | null => {
    if (!info.userId) {
        console.error("Missing userId when creating custom auth token")
        return null
    }

    if (!info.meetingId) {
        console.error("Missing meetingId when creating custom auth token")
        return null
    }

    if (info.authToken && info.authToken.length > 0) {
        return info.authToken
    }

    if (!info.joinCode) {
        return null
    }

    return `ivai ${info.userId}_${info.joinCode || ""}_${info.clientId || ""}`
}

export const batchFetchItems = async <T = any>(
    authToken: string,
    ids: string[],
    getUrl: (clientId: string | undefined, parameters: string) => URL,
    convertItem: (data: any) => T,
    clientId?: string,
    parameters?: string,
) => {

    if (ids.length === 0) {
        return []
    }

    const uniqueIds: string[] = []
    for (let id of ids) {
        if (!uniqueIds.includes(id)) {
            uniqueIds.push(id)
        } else {
            console.warn("Duplicate id provided to batch fetch")
        }
    }

    const batchSize = 100;
    const batches = [];

    for (let i = 0; i < uniqueIds.length; i += batchSize) {
        const batchIds = uniqueIds.slice(i, i + batchSize);
        const url = getUrl(clientId, parameters || batchIds.join(","));
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${authToken}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) throw new Error("Network response was not ok");
        const data = await response.json();
        batches.push(...data.map(convertItem).filter(Boolean));
    }

    return batches;
}